export default __webpack_public_path__ + "static/media/14.a91febf8.png";